import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.cl{gap:2rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.ap{text-align:center;}.ssr-plugin'
import '.ay{background-color:var(--brand-accent);}.ssr-plugin'
import '.hj{padding:0.25rem 1rem;}.ssr-plugin'
import '.hk{border-radius:1.75rem;}.ssr-plugin'
import { styled, type Style } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Button } from '@app/components/core/button/Button'
import { pages } from '@app/util/links'

export type LandingHeroProps = {
  badge: string
  title: string
  description: string
  ctaLabel?: string
  ctaTo?: string
  style?: Style
}

const LandingHero = ({
  badge,
  title,
  description,
  ctaLabel = 'Plan een demo',
  ctaTo = pages.contactUs,
  style,
}: LandingHeroProps) => {
  return (
    <styled.div className="a b r cl n ap"
      style={{
        ...style,
      }}
    >
      <span className="ay hj hk"
      >
        <Text.Small isBold>{badge}</Text.Small>
      </span>
      <Title.H1
        style={{
          marginBottom: 0,
          maxWidth: '57rem',
        }}
      >
        {title}
      </Title.H1>
      <Text.Medium
        style={{
          marginBottom: 0,
          maxWidth: '45rem',
        }}
      >
        {description}
      </Text.Medium>
      <Button label={ctaLabel} to={ctaTo} />
    </styled.div>
  )
}

export default LandingHero
